import PropTypes from 'prop-types';
import CustomDatepicker from '~/js/components/form-controls/CustomDatePicker';

const { Component } = React;

class FromTo extends Component {
  static propTypes = {
    dateFrom: PropTypes.string,
    dateTo: PropTypes.string,
    isRequired: PropTypes.bool,
    resetTo: PropTypes.bool,
    showError: PropTypes.bool,
    showFrom: PropTypes.bool,
    showTo: PropTypes.bool,
    enabledLabels: PropTypes.bool,
    fromLabelText: PropTypes.string,
    toLabelText: PropTypes.string,
    fromPlaceHolder: PropTypes.string,
    toPlaceHolder: PropTypes.string,
    wrapperClassNameFrom: PropTypes.string,
    wrapperClassNameTo: PropTypes.string,
    wrapperLabelClassNameFrom: PropTypes.string,
    wrapperLabelClassNameTo: PropTypes.string,
    toPast: PropTypes.bool,
    toFuture: PropTypes.bool,
  };

  static defaultProps = {
    dateFromName: 'dateFrom',
    dateToName: 'dateTo',
    isRequired: false,
    resetFrom: false,
    resetTo: false,
    showError: false,
    showTo: true,
    enabledLabels: false,
    fromLabelText: 'From',
    toLabelText: 'To',
    fromPlaceHolder: 'mm/dd/yyyy',
    toPlaceHolder: 'mm/dd/yyyy',
    wrapperClassNameFrom: 'xs-5 lg-3',
    wrapperClassNameTo: 'xs-5 lg-3',
    wrapperLabelClassNameFrom: 'xs-12 lg-5',
    wrapperLabelClassNameTo: 'xs-12 lg-5',
    toPast: false,
    toFuture: true,
  };

  constructor(props) {
    super(props);

    this.state = {
      startDate: '',
      endDate: '',
    };
  }

  handleDateToChange = (date) => {
    this.setState({ startDate: date },  () => {
      const { startDate, endDate } = this.state;

      if (new Date(startDate) > new Date(endDate)) {
        this.setState({ endDate: '', resetTo: true }, () => {
          this.setState({ resetTo: false, showError: true });
        });
      } else {
        this.setState({ showError: false });
      }
    });
  }

  handleDateFromChange = (date) => {
    this.setState({ endDate: date },  () => {
      const { startDate, endDate } = this.state;

      if (new Date(startDate) > new Date(endDate)) {
        this.setState({ endDate: '', resetTo: true }, () => {
          this.setState({ resetTo: false, showError: true });
        });
      } else {
        this.setState({ showError: false });
      }
    });
  }

  render() {
    const { startDate, resetTo, showError } = this.state;
    const { wrapperClassNameFrom, wrapperClassNameTo, enabledLabels, fromLabelText, toLabelText, wrapperLabelClassNameTo, wrapperLabelClassNameFrom, toPast, toFuture } = this.props;
    const wrapperClass = `${wrapperClassNameTo} ${startDate.length > 0 ? '' : 'disabled' }`;

    return(
      <div className="from-to-wrapper xs-12">
        <div className="row">
          { enabledLabels &&
          <label className={`form-label datepicker-label ${wrapperLabelClassNameFrom}`}>
            {fromLabelText} <span>*</span>
          </label>
          }
          <CustomDatepicker
            name={this.props.dateFromName}
            wrapperClassName={`from-datepicker ${wrapperClassNameFrom}`}
            updateExternalState={this.handleDateToChange}
            isRequired={this.props.isRequired}
            displayStringDate={false}
            displayPlaceHolder
            placeHolder={this.props.fromPlaceHolder}
            allowPast={toPast}
            allowFuture={toFuture}
          />
          { this.props.showTo &&
            <label className="form-label to-label xs-2 lg-2">
              To
            </label>
          }
          { enabledLabels &&
            <label className={`form-label datepicker-label ${wrapperLabelClassNameTo}`}>
              {toLabelText} <span>*</span>
            </label>
          }
          { !resetTo &&
            <CustomDatepicker
              name={this.props.dateToName}
              wrapperClassName={`to-datepicker ${wrapperClass}`}
              updateExternalState={this.handleDateFromChange}
              isRequired={this.props.isRequired}
              displayStringDate={false}
              displayPlaceHolder
              placeHolder={this.props.toPlaceHolder}
              allowPast={toPast}
              allowFuture={toFuture}
            />
          }
          { showError &&
            <label id="error" className="has-custom-error xs-12">Invalid Date Range.</label>
          }
        </div>
      </div>
    );
  }
}

export default FromTo;
